var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_60886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.667 1H12.667C6.59186 1 1.66699 5.92487 1.66699 12V63C1.66699 69.0751 6.59186 74 12.667 74H63.667C69.7421 74 74.667 69.0751 74.667 63V12C74.667 5.92487 69.7421 1 63.667 1Z",
    fill: "#5ABA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2793 55.2383C48.3018 55.2383 56.4267 47.1134 56.4267 37.0908C56.4267 27.0682 48.3018 18.9434 38.2793 18.9434C28.2567 18.9434 20.1318 27.0682 20.1318 37.0908C20.1318 47.1134 28.2567 55.2383 38.2793 55.2383Z",
    fill: "#50B651"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6262 41.5604C42.9898 41.5604 40.8525 39.3622 40.8525 36.6508C40.8525 33.9395 42.9898 31.7417 45.6262 31.7417C48.2625 31.7417 50.4003 33.9395 50.4003 36.6508C50.4003 39.3622 48.263 41.5604 45.6262 41.5604ZM45.66 40.0031C47.3055 40.0031 48.641 38.5022 48.641 36.6508C48.641 34.7995 47.3055 33.2999 45.66 33.2999C44.0146 33.2999 42.6791 34.8008 42.6791 36.6517C42.6791 38.5027 44.0146 40.0031 45.66 40.0031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7764 27.7886H39.2163V41.5056H37.3279V29.2931H35.7764V27.7886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2123 31.8807H34.9978V43.3358C34.9978 44.3796 33.8998 45.4668 32.8298 45.9347C32.3239 46.1557 31.3905 46.287 30.0294 46.3286V45.189C31.3606 45.0406 32.2592 44.7444 32.725 44.3006C32.9938 43.9271 33.1618 43.4906 33.2128 43.0332V39.6679C32.7355 40.6805 32.1345 41.3518 31.4097 41.6818C30.6564 42.0883 29.1229 42.0215 28.4969 41.6818C27.8709 41.3422 26.9527 40.4479 26.5317 39.1159C26.4152 38.7483 26.1252 37.7478 26.1555 36.6878C26.1826 35.6783 26.5168 34.6101 26.7946 34.1711C27.2716 33.4213 28.0236 32.4823 29.1627 32.0898C29.7191 31.898 30.7504 31.8291 32.2566 31.883V33.0162C31.1374 32.9406 30.4391 32.9784 30.1618 33.1296C29.7458 33.3554 28.8068 33.6341 28.4969 35.6806C28.1871 37.7271 28.506 39.4018 29.4883 39.9262C29.8248 40.1069 30.4201 40.3205 30.9703 40.1322C32.0272 39.7708 33.0217 38.4822 33.0976 37.6092C33.1741 36.7233 33.2123 34.8138 33.2123 31.8807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3022 15.8652C26.6131 15.8652 17.1367 25.3412 17.1367 37.0303C17.1367 48.7193 26.6131 58.1957 38.3022 58.1957C49.9913 58.1957 59.4677 48.7193 59.4677 37.0303C59.4677 25.3412 49.9913 15.8652 38.3022 15.8652ZM38.3022 54.9026C28.432 54.9026 20.4303 46.9009 20.4303 37.0307C20.4303 30.8989 23.5183 25.4884 28.2238 22.2703C31.1913 20.2378 34.7054 19.1528 38.3022 19.1583C48.1725 19.1583 56.1741 27.1596 56.1741 37.0303C56.1748 38.2575 56.0496 39.4816 55.8006 40.6833C54.1146 48.802 46.9204 54.9026 38.3022 54.9026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.667 1H12.667C6.59186 1 1.66699 5.92487 1.66699 12V63C1.66699 69.0751 6.59186 74 12.667 74H63.667C69.7421 74 74.667 69.0751 74.667 63V12C74.667 5.92487 69.7421 1 63.667 1Z",
    stroke: "#5ABA4A",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_60886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlo);
export default __webpack_public_path__ + "static/media/glo.5a339069a74928f2ffbeee14c9db2035.svg";
export { ForwardRef as ReactComponent };